import { Card } from '@purpur/library';
import styled from 'styled-components';

import {
    getPurpurColor,
    getPurpurSpacing,
    getPurpurTypography,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

import { StyledAuthorBadge } from '../common/AuthorBadge/AuthorBadge.styles';

export const CardMediaLayout = styled(Card.MediaLayout)`
    grid-template-rows: auto 1fr;
    flex-grow: 1;

    ${StyledAuthorBadge} {
        margin-top: auto;
    }
`;

export const CardDetailsContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: ${getPurpurSpacing('100')};
    gap: ${getPurpurSpacing('200')};

    [class^='_purpur-card-badge'] {
        position: relative;
        top: 0;
        right: 0;
    }
`;

export const CardDate = styled.div`
    color: ${getPurpurColor('textMedium')};
    font-size: ${getPurpurTypography('scale75')};
    line-height: ${getPurpurTypography('lineHeightLoose')};
`;

export const StyledMediaFallback = styled.div`
    width: 100%;
    height: 100%;
    padding: ${getPurpurSpacing('200')};
    aspect-ratio: 2 / 1;
    display: flex;
    align-items: center;
    justify-content: center;

    ${purpurMedia('md')`
       padding-bottom: 0;
    `};

    img {
        display: none;
    }

    @container card (min-width: 600px) {
        aspect-ratio: auto;
    }
`;

export const IllustrativeContainer = styled.div`
    width: 7.75rem;
    height: 7.75rem;
`;
